import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  getEleBill: baseURL + '/common/openapi/settlment/ele/bill'
};

export default api;
